import { retry } from '@wix/funnel-utils'

import { withMonitoring } from '../monitoring/withMonitoring'
import { httpClient } from './httpClient'

export type ProvisionHeadlessParams = {
  metaSiteId: string
  origin: string
  ref?: string
  businessName?: string
  category?: {
    industryId?: string
    structureId?: string
    displayName?: string
    postRegVertical?: string
    businessTermId?: string
    businessSegmentId?: string
  }
  selectedApps?: { appDefId: string }[]
}

export const provisionHeadlessMetaSite = async (params: ProvisionHeadlessParams) => {
  const request = () => httpClient.post('/api/provisionHeadless', params)
  const requestWithRetry = () => retry(request)
  return withMonitoring(requestWithRetry, 'provisionHeadlessMetaSite')
}
